import {
  DASHBOARD_KPI_CARDS,
  DASHBOARD_COUNTRIES,
  DASHBOARD_ENTITIES,
  DASHBOARD_CURRENCIES,
  DASHBOARD_VALUE_CONVERSIONS,
  DASHBOARD_MONTHLY_LIABILITY_ANALYSIS,
  DASHBOARD_MONTHLY_VARIANCE_ANALYSIS,
  DASHBOARD_COMPLIANCE_PERFORMANCE_OVERVIEW,
  DASHBOARD_TOP_WHT_CONTRIBUTING_VENDORS,
  DASHBOARD_TOP_WHT_PAYMENT_CATEGORIES,
  DASHBOARD_WHT_VARIANCE_SUMMARY,
  DASHBOARD_COMPLIANCE_SUMMARY,
  DASHBOARD_COMPLIANCES,
  DASHBOARD_COMPLIANCE_ROWS,
  DASHBOARD_COMPLIANCES_DOWNLOAD,
  DASHBOARD_LAST_SYNCED_DATE,
  COMPLIANCE_MASTER_BASE_API,
} from '@/endpoints/apiEndpoints'
import {
  buildRequestHeader,
  handleErrorResponse,
  handleRequestFailure,
  handleSuccessResponse,
  urlBuilder,
} from '@/api/apiUtils'

export const getDashboardKpiCards = async payload => {
  try {
    const url = urlBuilder(DASHBOARD_KPI_CARDS)
    const options = buildRequestHeader('POST', payload)
    const response = await fetch(url, options)
    if (!response.ok) {
      await handleRequestFailure(response)
    }
    return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const getDashboardCountries = async () => {
  try {
    const url = urlBuilder(DASHBOARD_COUNTRIES)
    const response = await fetch(url, buildRequestHeader('GET'))
    if (!response.ok) {
      await handleRequestFailure(response)
    }
    return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const getDashboardEntities = async (countryCodes = []) => {
  try {
    const url = urlBuilder(DASHBOARD_ENTITIES)
    const options = buildRequestHeader('POST', { countryCodes })
    const response = await fetch(url, options)
    if (!response.ok) {
      await handleRequestFailure(response)
    }
    return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const getDashboardCurrencies = async () => {
  try {
    const url = urlBuilder(DASHBOARD_CURRENCIES)
    const response = await fetch(url, buildRequestHeader('GET'))
    if (!response.ok) {
      await handleRequestFailure(response)
    }
    return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const getDashboardValueConversions = async () => {
  try {
    const url = urlBuilder(DASHBOARD_VALUE_CONVERSIONS)
    const response = await fetch(url, buildRequestHeader('GET'))
    if (!response.ok) {
      await handleRequestFailure(response)
    }
    return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const getMonthlyLiabilityAnalysis = async payload => {
  try {
    const url = urlBuilder(DASHBOARD_MONTHLY_LIABILITY_ANALYSIS)
    const options = buildRequestHeader('POST', payload)
    const response = await fetch(url, options)
    if (!response.ok) {
      await handleRequestFailure(response)
    }
    return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const getMonthlyVarianceAnalysis = async payload => {
  try {
    const url = urlBuilder(DASHBOARD_MONTHLY_VARIANCE_ANALYSIS)
    const options = buildRequestHeader('POST', payload)
    const response = await fetch(url, options)
    if (!response.ok) {
      await handleRequestFailure(response)
    }
    return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const getCompliancePerformanceOverview = async payload => {
  try {
    const url = urlBuilder(DASHBOARD_COMPLIANCE_PERFORMANCE_OVERVIEW)
    const options = buildRequestHeader('POST', payload)
    const response = await fetch(url, options)
    if (!response.ok) {
      await handleRequestFailure(response)
    }
    return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const getTopWhtContributingVendors = async payload => {
  try {
    const url = urlBuilder(DASHBOARD_TOP_WHT_CONTRIBUTING_VENDORS)
    const options = buildRequestHeader('POST', payload)
    const response = await fetch(url, options)
    if (!response.ok) {
      await handleRequestFailure(response)
    }
    return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const getTopWhtPaymentCategories = async payload => {
  try {
    const url = urlBuilder(DASHBOARD_TOP_WHT_PAYMENT_CATEGORIES)
    const options = buildRequestHeader('POST', payload)
    const response = await fetch(url, options)
    if (!response.ok) {
      await handleRequestFailure(response)
    }
    return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const getWhtVarianceSummary = async payload => {
  try {
    const url = urlBuilder(DASHBOARD_WHT_VARIANCE_SUMMARY)
    const options = buildRequestHeader('POST', payload)
    const response = await fetch(url, options)
    if (!response.ok) {
      await handleRequestFailure(response)
    }
    return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const getComplianceSummary = async payload => {
  try {
    const url = urlBuilder(DASHBOARD_COMPLIANCE_SUMMARY)
    const options = buildRequestHeader('POST', payload)
    const response = await fetch(url, options)
    if (!response.ok) {
      await handleRequestFailure(response)
    }
    return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const getDashboardCompliances = async payload => {
  try {
    const url = urlBuilder(DASHBOARD_COMPLIANCES)
    const options = buildRequestHeader('POST', payload)
    const response = await fetch(url, options)
    if (!response.ok) {
      await handleRequestFailure(response)
    }
    return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const getDashboardComplianceRows = async payload => {
  try {
    const url = urlBuilder(DASHBOARD_COMPLIANCE_ROWS)
    const options = buildRequestHeader('POST', payload)
    const response = await fetch(url, options)
    if (!response.ok) {
      await handleRequestFailure(response)
    }
    return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const updateComplianceCompletionDate = async (uuid, completionDate) => {
  try {
    const url = urlBuilder(
      `${COMPLIANCE_MASTER_BASE_API}/${uuid}/completion-date`
    )
    const options = buildRequestHeader('PATCH', { completionDate })
    const response = await fetch(url, options)
    if (!response.ok) {
      await handleRequestFailure(response)
    }
    return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const getDashboardLastSyncedDate = async () => {
  try {
    const url = urlBuilder(DASHBOARD_LAST_SYNCED_DATE)
    const response = await fetch(url, buildRequestHeader('GET'))
    if (!response.ok) {
      await handleRequestFailure(response)
    }
    return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const downloadDashboardCompliances = async payload => {
  try {
    const url = urlBuilder(DASHBOARD_COMPLIANCES_DOWNLOAD)
    const options = buildRequestHeader('POST', payload)
    const response = await fetch(url, options)
    if (!response.ok) {
      await handleRequestFailure(response)
    }
    return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}
